var map = {
	"./paper-1.png": "8ea0",
	"./paper-2.png": "6ef2",
	"./paper-3.png": "dc76",
	"./paper-4.png": "1c86",
	"./paper-5.png": "2e4e",
	"./paper-6.png": "775d",
	"./paper-7.png": "8489",
	"./paper-8.png": "923d",
	"./paper-9.png": "de16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7527";